var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpStickerSpecialIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-stickerspecial-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.771,
    cy: 82.988,
    r: 41,
    style: {
      fill: "#3c3c46",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.77,117.987a41,41,0,1,0-41-41A41.079,41.079,0,0,0,69.77,117.987Z",
    style: {
      fill: "#3ca5f0",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.77,113.987a41,41,0,1,0-41-41A41.079,41.079,0,0,0,71.77,113.987Z",
    style: {
      fill: "#3ca5f0",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.77,109.987a41,41,0,1,0-41-41A41.079,41.079,0,0,0,67.77,109.987Z",
    style: {
      fill: "#3ca5f0",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.675,66.921a41,41,0,1,1-43.84-43.84Z",
    style: {
      fill: "#8adafc",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.782,22.975a41,41,0,0,1,41,41c0,.967-.036,1.926-.1,2.877L65.835,23.081C66.82,23.019,67.794,22.975,68.782,22.975Z",
    style: {
      fill: "#fff0e1",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.733,66.958a41,41,0,0,1-41-41c0-.967.036-1.926.1-2.877l43.844,43.77C108.695,66.914,107.721,66.958,106.733,66.958Z",
    style: {
      fill: "#fff",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1,61.365,45.107,64.1a.261.261,0,0,0,.491,0L46.6,61.365a8.056,8.056,0,0,1,4.771-4.771l2.732-1.008a.262.262,0,0,0,0-.491l-2.733-1.008A8.056,8.056,0,0,1,46.6,49.317L45.6,46.584a.261.261,0,0,0-.491,0L44.1,49.317a8.056,8.056,0,0,1-4.771,4.771L36.6,55.1a.262.262,0,0,0,0,.491l2.732,1.008A8.055,8.055,0,0,1,44.1,61.365Z",
    style: {
      fill: "#ffed00",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.88,68.509,70.147,67.5a8.055,8.055,0,0,1-4.771-4.771L64.369,60a.262.262,0,0,0-.491,0L62.87,62.73A8.057,8.057,0,0,1,58.1,67.5l-2.732,1.007a.261.261,0,0,0,0,.491L58.1,70.008a8.057,8.057,0,0,1,4.771,4.771l1.008,2.732a.262.262,0,0,0,.491,0l1.008-2.732a8.055,8.055,0,0,1,4.771-4.771L72.88,69a.261.261,0,0,0,0-.491Z",
    style: {
      fill: "#f3424c",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.353,75.578,94.5,74.893a5.476,5.476,0,0,1-3.243-3.243l-.685-1.857a.178.178,0,0,0-.333,0L89.55,71.65a5.475,5.475,0,0,1-3.243,3.243l-1.857.685a.178.178,0,0,0,0,.333l1.857.684a5.476,5.476,0,0,1,3.242,3.243l.685,1.857a.178.178,0,0,0,.333,0l.685-1.857A5.474,5.474,0,0,1,94.5,76.6l1.857-.685a.178.178,0,0,0,0-.333Z",
    style: {
      fill: "#1d70b7",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.278,87.691l-1.533-.566a4.518,4.518,0,0,1-2.676-2.676L75.5,82.917a.147.147,0,0,0-.275,0l-.566,1.532a4.517,4.517,0,0,1-2.676,2.676l-1.533.566a.147.147,0,0,0,0,.275l1.532.566a4.518,4.518,0,0,1,2.676,2.676l.565,1.532a.147.147,0,0,0,.275,0l.565-1.532a4.518,4.518,0,0,1,2.676-2.676l1.532-.566a.146.146,0,0,0,0-.275Z",
    style: {
      fill: "#fff",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.672,40.914l-1.3-.478a3.819,3.819,0,0,1-2.261-2.262l-.478-1.295a.124.124,0,0,0-.232,0l-.478,1.295a3.819,3.819,0,0,1-2.262,2.262l-1.3.478a.124.124,0,0,0,0,.232l1.3.478a3.818,3.818,0,0,1,2.262,2.262l.478,1.295a.124.124,0,0,0,.232,0l.478-1.3a3.819,3.819,0,0,1,2.262-2.262l1.3-.478a.124.124,0,0,0,0-.233Z",
    style: {
      fill: "#3ca5f0",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.435,80.872l-1.629-.6a4.8,4.8,0,0,1-2.845-2.845l-.6-1.629a.156.156,0,0,0-.293,0l-.6,1.629a4.8,4.8,0,0,1-2.845,2.845l-1.629.6a.156.156,0,0,0,0,.292l1.629.6a4.8,4.8,0,0,1,2.845,2.845l.6,1.629a.156.156,0,0,0,.293,0l.6-1.629a4.8,4.8,0,0,1,2.845-2.845l1.629-.6a.156.156,0,0,0,0-.292Z",
    style: {
      fill: "#fff",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.728,
    y1: 17.637,
    x2: 68.728,
    y2: 5.478,
    style: {
      fill: "none",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.735,
    y1: 19.218,
    x2: 82.288,
    y2: 13.423,
    style: {
      fill: "none",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.924,
    y1: 23.853,
    x2: 98.004,
    y2: 13.322,
    style: {
      fill: "none",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.532,
    y1: 31.225,
    x2: 105.774,
    y2: 26.982,
    style: {
      fill: "none",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.904,
    y1: 40.833,
    x2: 119.434,
    y2: 34.753,
    style: {
      fill: "none",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.539,
    y1: 52.021,
    x2: 119.334,
    y2: 50.468,
    style: {
      fill: "none",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.338,
    y1: 64.028,
    x2: 10.178,
    y2: 64.028,
    style: {
      fill: "none",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.918,
    y1: 52.021,
    x2: 18.123,
    y2: 50.468,
    style: {
      fill: "none",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.553,
    y1: 40.833,
    x2: 18.023,
    y2: 34.753,
    style: {
      fill: "none",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.925,
    y1: 31.225,
    x2: 31.682,
    y2: 26.982,
    style: {
      fill: "none",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.533,
    y1: 23.853,
    x2: 39.453,
    y2: 13.322,
    style: {
      fill: "none",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.722,
    y1: 19.218,
    x2: 55.169,
    y2: 13.423,
    style: {
      fill: "none",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9998px"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpStickerSpecialIcon);
export default __webpack_public_path__ + "static/media/cp-sticker-special-icon.dec2bbdd9fdca5465892b94b6cb7c499.svg";
export { ForwardRef as ReactComponent };